import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";
import Reveal from "../components/Reveal";

export default function CollectionsIndex() {
  const [cols, setCols] = useState([]);
  useEffect(() => { http.get("/collections").then((r) => setCols(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12">
      <h1 className="font-display text-5xl sm:text-7xl text-white uppercase tracking-tight mb-8">Collections</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        {cols.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.06}>
            <Link to={`/collection/${c.slug}`} className="group relative block h-80 sm:h-[460px] overflow-hidden bg-zinc-950">
              <img src={c.cover_image} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8">
                {c.effective_status === "scheduled" && <span className="text-[10px] uppercase tracking-widest text-accent font-semibold mb-1">Coming Soon</span>}
                <h2 className="font-display text-5xl text-white uppercase tracking-tight">{c.name}</h2>
                <p className="text-zinc-300 text-sm mt-2 max-w-sm">{c.short_description}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
